import http from 'hub-http/clients/apiClient';
import getEarlyRequesterResultPromise from 'ContentEditorUI/earlyRequester/getEarlyRequesterResultPromise';
import rpcClient from 'ContentEditorUI/api/RpcClient';
import { getRevisionsRpc, restoreRevisionRpc } from '../../__generated__/chirp/com/hubspot/contentstaging/rpc/ContentStagingRevisionsRpc';
export const CURRENT_REVISION_ID = -1;
export function fetchRevisions({
  baseContentUrl,
  limit = 15,
  offset = 0
}) {
  const earlyRequest = getEarlyRequesterResultPromise('versionsCounted');
  return earlyRequest || http.get(`${baseContentUrl}/versions-counted`, {
    query: {
      limit,
      offset
    }
  });
}
export function selectRevision({
  baseContentUrl,
  versionId,
  shouldRestoreToBuffer,
  shouldRestoreScheduledUpdateToBuffer
}) {
  const bufferPostfix = shouldRestoreToBuffer ? 'restore-to-buffer' : 'restore';
  const data = shouldRestoreScheduledUpdateToBuffer ? {
    scheduledBufferId: versionId
  } : {
    versionId
  };
  return http.post(`${baseContentUrl}/${shouldRestoreScheduledUpdateToBuffer ? 'scheduled' : 'versions'}/${bufferPostfix}`, {
    data
  });
}
export function fetchScheduledVersion(baseContentUrl) {
  return http.get(`${baseContentUrl}/scheduled`);
}
export function fetchStagedRevisions({
  contentId,
  limit = 15,
  offset = 0
}) {
  return rpcClient.call(getRevisionsRpc, {
    request: {
      contentId,
      pageLength: limit,
      offset: {
        index: offset
      }
    }
  }).then(r => {
    var _r$results, _r$offset$index, _r$offset;
    return {
      objects: ((_r$results = r.results) !== null && _r$results !== void 0 ? _r$results : []).map(rev => Object.assign({}, rev, {
        id: rev.revisionId
      })),
      total: r.total,
      limit,
      offset: (_r$offset$index = (_r$offset = r.offset) === null || _r$offset === void 0 ? void 0 : _r$offset.index) !== null && _r$offset$index !== void 0 ? _r$offset$index : offset
    };
  });
}
export function restoreStagedRevision({
  contentId,
  revisionId
}) {
  return rpcClient.call(restoreRevisionRpc, {
    request: {
      contentId,
      revisionId
    }
  });
}